module.exports =  {

  howToCancelOrder: {
    title: 'How to Cancel an Order?',
    contents: `
      <p>If you are the taker (filling other people's orders) and the trade has been completed,
        you can't cancel it.</p>
        <p>If you are the maker (creating a new order for other people to fill), if the order is
        still valid (not expired or fully filled), you can cancel it. To cancel an order, go to
      "My Orders", find your order and click on the "Cancel" button (you won't see this button if
      this order is no longer fillable).</p>
        <p>Please note that you need to pay gas fee when you cancel an order.</p>
  `,
  },

}
